// extracted by mini-css-extract-plugin
export default {"legend":"styles-module__legend__e6a4bae1ecf13c2a5cbe"};